// Single source of truth for legal-document versions. Bumping VERSION (or
// COOKIE_CONSENT_VERSION) invalidates any prior dismissal stored in
// localStorage and re-prompts the candidate.
// 1.4.1 (2026-09-10): Paddle go-live — Terms §6/§14, the new Refund Policy, the
// product named CandidCheck, Paddle disclosed as a recipient. A patch number on
// purpose: 1.5 is already reserved for Emilia's privacy bump (OpenRouter EU,
// CP-11/12/14/20) and 1.6 for OPS-15, and both are referenced by that number.
// 1.6 (2026-09-14): stored files — camera photos (EF-8) and uploaded answer
// files (EF-11) disclosed in the Candidate Privacy Notice, the Privacy Policy
// and Cloudflare on the Sub-processors page. Reaching 1.6 is what lets
// production switch Build B on (backend/legal_version.py). Published as an
// OPERATOR DRAFT ahead of the vendor's OPS-15 review; 1.5's content
// (OpenRouter EU, CP-11/12/14/20, B7) is NOT in it and is still owed.
export const LAST_UPDATED = "2026-09-14";
export const VERSION = "1.6";
export const COOKIE_CONSENT_VERSION = "1.0";

export const COOKIE_CONSENT_STORAGE_KEY = "cookieConsentVersion";
